import React from "react"
import { Typography } from "antd"
import { MappedCourse } from "../../lib/prismic/MappedCourse"
import { StyledParagraph } from "../StyledParagraph/StyledParagraph"

interface CoursePriceProps {
  course: MappedCourse
}

export const CoursePrice: React.FC<CoursePriceProps> = ({ course }) => {
  const { price, lessonCount } = course

  const isFree = price === 0
  const pricePerLesson = !isFree && lessonCount && lessonCount > 0 ? Math.round(price / lessonCount) : null

  return (
    <>
      <Typography.Title level={2}>Cena kroužku</Typography.Title>
      <StyledParagraph>
        {isFree ? (
          "Kroužek je zdarma."
        ) : (
          <>
            Cena kroužku je {price} Kč včetně DPH
            {pricePerLesson !== null && <> ({pricePerLesson} Kč za lekci)</>}.
          </>
        )}
      </StyledParagraph>
    </>
  )
}
